import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigClient } from 'src/shared/services/api.service';

@Component({
  standalone: false,
  selector: 'edportal-unhandled-error',
  templateUrl: './unhandled-error.component.html',
  styles: ``,
})
export class UnhandledErrorComponent {
  @Input() traceId!: string;
  @Input() errorId!: string;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly configClient: ConfigClient,
  ) {}

  onReportError() {
    this.configClient
      .reportError({
        site: 'Educator Portal',
        traceId: this.traceId,
        errorId: this.errorId,
      })
      .subscribe(() => {
        this.activeModal.close();
      });
  }

  onCancel() {
    this.activeModal.close();
  }
}
